import { render } from "./DecoderWidget.vue?vue&type=template&id=4da6e95f"
import script from "./DecoderWidget.vue?vue&type=script&lang=js"
export * from "./DecoderWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__